/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MenuItemSearchEssential
 */
export interface MenuItemSearchEssential {
    /**
     * 
     * @type {string}
     * @memberof MenuItemSearchEssential
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuItemSearchEssential
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MenuItemSearchEssential
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof MenuItemSearchEssential
     */
    price: number;
}

/**
 * Check if a given object implements the MenuItemSearchEssential interface.
 */
export function instanceOfMenuItemSearchEssential(value: object): value is MenuItemSearchEssential {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    return true;
}

export function MenuItemSearchEssentialFromJSON(json: any): MenuItemSearchEssential {
    return MenuItemSearchEssentialFromJSONTyped(json, false);
}

export function MenuItemSearchEssentialFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuItemSearchEssential {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'price': json['price'],
    };
}

export function MenuItemSearchEssentialToJSON(json: any): MenuItemSearchEssential {
    return MenuItemSearchEssentialToJSONTyped(json, false);
}

export function MenuItemSearchEssentialToJSONTyped(value?: MenuItemSearchEssential | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'price': value['price'],
    };
}

